import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../network/appClient';
import { useToken } from '../store/auth/tokenStore';
import { DependentDTO, DependentsOwnerDTO } from '../DTO/dependentsResponseDTO';
import { LogInResponseDTO } from '../DTO/authDTO';

export const useGetDependentsOwner = (user?: LogInResponseDTO) => {
    const ownerOption = useMemo<DependentDTO[]>(() => {
        if (!user) return [];

        return [
            {
                id: user.personId || 0,
                phone: String(user.phone || ''),
                active: true,
                email: user.email || '',
                personId: user.personId || 0,
                foreigner: !!user.language && user.language !== 'pt_br',
                birthDate: user.birthDate || '',
                document: user.document || '',
                name: user.name || '',
            },
        ];
    }, [user]);

    const { isPending, data } = useQuery({
        enabled: [2, 7, 10, 12, 13].some(
            enumKey => enumKey === user?.accessProfile.enumKey
        ),
        queryKey: ['dependentsOwner'],
        queryFn: async () => {
            const response = await axiosClient.get<DependentsOwnerDTO>(
                '/Dependent?StatusId=1',
                {
                    headers: {
                        Authorization: `Bearer ${useToken.getState().token}`,
                    },
                }
            );
            return response.data.dependents;
        },
        throwOnError: () => false,
    });

    return {
        isPendingDependents: isPending,
        dependents: ownerOption.concat(data || []),
    };
};
